module.exports = __webpack_public_path__ + "img/blueAdd.26d861e2.svg";